<template>
  <div :class="['service-with-searchbar-box', shelfIndex !== 0 ? 'no-margin-top' : '']">
    <div class="overflow-scrolling-box">
      <div class="list-top list-top-division list-top-division--top">
        <!-- 道具平铺 -->
        <div v-show="propsList && propsList.length" class="list-top-item" style="background: #fff">
          <div class="limit-active skin-module">
            <h3 v-show="!noTitle && shelfConfig.title" class="limit-active-title">
              {{ shelfConfig.title }}
              <button v-show="shelfConfig.linkTabId" class="enter-btn" @click="goMore">更多</button>
            </h3>
            <div :class="{ 'limit-active-wrap-box': isRating && propsList.length > 1 }">
              <!-- 评分货架英雄卡片 两列排版， 当英雄和皮肤有一个请求失败的时候，只有一列的数据。则不再使用两列排版。 -->
              <template v-if="isRating">
                <div v-for="(rankList, idx) in propsList" :key="'rank' + idx" :class="{ 'column-container': isRating }">
                  <div
                    class="limit-active-wrap limit-active-list"
                    :style="{ paddingTop: !noTitle && shelfConfig.title ? '0.03rem' : '0.16rem' }"
                  >
                    <div
                      v-for="(goods, index) in rankList.list"
                      :key="'goods' + index"
                      :ref="'single-prop' + index"
                      class="swiper-slide swiper-slide-porps-holder"
                      @click="goToPropPage(goods, index)"
                    >
                      <single-prop
                        :goods="goods"
                        :game-coin-icon="gameCoinIcon"
                        :game-coin-unit="gameCoinUnit"
                        :is-rating="isRating"
                        :tag-style="tagStyle"
                      ></single-prop>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 其他 -->
              <template v-else>
                <div
                  v-if="!showPageTurn"
                  class="limit-active-wrap limit-active-list"
                  :style="{ paddingTop: !noTitle && shelfConfig.title ? '0.03rem' : '0.16rem' }"
                >
                  <div
                    v-for="(goods, index) in propsList"
                    :key="'goods' + index"
                    class="swiper-slide swiper-slide-porps-holder"
                    @click="goToPropPage(goods, index)"
                  >
                    <single-prop :goods="goods" :game-coin-icon="gameCoinIcon" :game-coin-unit="gameCoinUnit"></single-prop>
                  </div>
                </div>

                <!-- 道具换一批显示 -->
                <div
                  v-if="showPageTurn"
                  class="limit-active-wrap limit-active-list"
                  :style="{ paddingTop: !noTitle && shelfConfig.title ? '0.03rem' : '0.16rem' }"
                >
                  <div
                    v-for="(goods, index) in showGoodsList"
                    :key="'goods' + index"
                    class="swiper-slide swiper-slide-porps-holder"
                    @click="goToPropPage(goods, index)"
                  >
                    <single-prop :goods="goods" :game-coin-icon="gameCoinIcon" :game-coin-unit="gameCoinUnit"></single-prop>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div v-if="showPageTurn" class="change-btn" @click="changeBatch">
            <i class="change-icon"></i>
            <span>换一批</span>
          </div>
        </div>

        <!-- 道具正在更新 -->
        <div v-show="!(propsList && propsList.length) && !(placeholderGoods && placeholderGoods.length) && !isLoading" class="page">
          <h3 v-show="!noTitle && shelfConfig.title" class="limit-active-title">{{ shelfConfig.title }}</h3>
          <img class="content-empty-img" style="margin: 0 auto 0.2rem; padding-top: 0.2rem" :src="noFoundImg" />
          <p class="content-empty-tips" style="margin-bottom: 0">{{ noGoodsTips }}</p>
        </div>

        <!-- 占位图 -->
        <div
          v-show="placeholderGoods && placeholderGoods.length && !propsList.length && !isRating"
          class="list-top-item list-top-item--loading"
        >
          <div class="limit-active skin-module">
            <h3 v-show="!noTitle && shelfConfig.title" class="limit-active-title">
              <!-- {{ shelfConfig.title }} -->
            </h3>
            <div class="limit-active-wrap limit-active-list" :style="{ paddingTop: !noTitle && shelfConfig.title ? '0.03rem' : '0.16rem' }">
              <div
                v-for="(goods, index) in placeholderGoods"
                :key="'placeholderGoods' + index"
                class="swiper-slide swiper-slide-porps-holder"
              >
                <single-prop :goods="goods" :game-coin-icon="gameCoinIcon" :game-coin-unit="gameCoinUnit"></single-prop>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isRating && !(propsList && propsList.length) && !isLoading" class="limit-active-list-null">
        <img class="empty-img" src="../../../../ui/assets/mobile/images/404.png" alt="" />
        <p>暂未榜单数据</p>
      </div>
    </div>
  </div>
</template>
<script>
import singlePropHolder from "../basic/singlePropHolder.vue"
import * as helper from "@utils/helper"
import { mapGetters, mapActions } from "vuex"
import gameServiceZoneMixin from "../../mixins/gameServiceZone"

export default {
  components: {
    "single-prop": singlePropHolder
  },

  mixins: [gameServiceZoneMixin],

  props: [
    "shelfConfig",
    "shelfIndex",
    "propsList",
    "placeholderGoods",
    "gameCoinIcon",
    "gameCoinUnit",
    "noGoodsTips",
    "goToPropPage",
    "isLoading",
    "isRating",
    "classifyMenuConfig",
    "assignNoTitle"
  ],
  data() {
    return {
      noFoundImg: require("../../../../ui/assets/mobile/images/coupon-empty.png"),
      placeholderBg: require("../../../../ui/assets/mobile/images/placeholder-bg.png"),
      // 当前展示页数（支持换一批）
      pageIndex: 0,
      // 货架一页内展示个数
      pageSize: 4
    }
  },
  computed: {
    ...mapGetters(["preLoadIconMap"]),
    // 本页展示的推荐道具数据
    showGoodsList() {
      let showGoodsList = []
      if (this.propsList && this.propsList.length) {
        let start = (this.pageIndex * this.pageSize) % this.propsList.length
        let end = ((this.pageIndex + 1) * this.pageSize) % this.propsList.length
        if (end < start) {
          showGoodsList = [...this.propsList.slice(start, ~~start + ~~this.pageSize), ...this.propsList.slice(0, end)]
        } else {
          showGoodsList = this.propsList.slice(start, ~~start + ~~this.pageSize)
        }
      }

      // 预加载图片
      if (this.pageIndex * this.pageSize < this.propsList.length) {
        this.propsList.slice(this.pageIndex * this.pageSize, (this.pageIndex + 2) * this.pageSize).forEach(item => {
          if (!this.preLoadIconMap[item.goodsId]) {
            this.setPreLoadIcon({
              key: item.goodsId,
              icon: item.icon && helper.preLoadImg(item.icon)
            })
          }
        })
      }

      return showGoodsList
    },
    showPageTurn() {
      //设置分页阈值且道具个数大于阈值，则显示分页换一批
      return this.shelfConfig && this.shelfConfig.pageThreshold > 0 && this.propsList.length > this.shelfConfig.pageThreshold
    },
    noTitle() {
      return (this.shelfConfig && this.shelfConfig.noTitle) || this.assignNoTitle
    },
    // 标签样式 ranking score none  默认 score
    tagStyle() {
      return (this.classifyMenuConfig && this.classifyMenuConfig.tagStyle) || "score"
    }
  },

  methods: {
    ...mapActions(["setPreLoadIcon"]),

    // 换一批
    changeBatch() {
      this.pageIndex++
    },

    goMore() {
      if (this.shelfConfig.linkTabId) {
        this.goToOtherTab(this.shelfConfig.linkTabId)
      }
      //   this.reportUserAction({
      //     iformat: reportDict.CLICK.SERVICEZONE_SHELF_GOODS_MORE,
      //     pfStructure: this.$route.query.pfStructure
      //   })
    }
  }
}
</script>
